import AppraisalApi from './AppraisalApi';
import FeaturesApi from './FeaturesApi';

class Api {
  appraisal = new AppraisalApi();

  features = new FeaturesApi();
}

export default Api;
